(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/lastmatches-model.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/lastmatches-model.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.LastMatch = Backbone.Model.extend({
    defaults: {
      teamId: undefined
    },

    initialize: function(teamId) {
      this.set('teamId', teamId, { silent: true });
    },

    setLastMatchValues: function(matches) {
      var result = [],
        trend = [],
        self = this,
        finalResult,
        homeScore,
        awayScore,
        isHomeWin,
        isAwayWin,
        isDraw,
        teamIsHomeTeam,
        nrOfGoals = 0,
        goalAverage = 0;

      _.each(matches, function(matchItem) {
        finalResult =
          _.findWhere(matchItem.match.result, { isFinalResult: true }) ||
          matchItem.match.result[0];
        if (finalResult) {
          homeScore = parseInt(finalResult.home, 10);
          awayScore = parseInt(finalResult.away, 10);
          isHomeWin = homeScore > awayScore;
          isAwayWin = homeScore < awayScore;
          isDraw = homeScore === awayScore;
          teamIsHomeTeam = matchItem.match.homeTeam.id === self.get('teamId');
          nrOfGoals += teamIsHomeTeam ? homeScore : awayScore;

          if (isHomeWin) {
            if (teamIsHomeTeam) {
              result.push('V');
              trend.push(3);
            } else {
              result.push('F');
              trend.push(0);
            }
          } else if (isAwayWin) {
            if (teamIsHomeTeam) {
              result.push('F');
              trend.push(0);
            } else {
              result.push('V');
              trend.push(3);
            }
          } else if (isDraw) {
            result.push('O');
            trend.push(1);
          }
        }
      });
      goalAverage = svs.utils.format.Odds(nrOfGoals / matches.length);

      this.set({
        lastMatches: result,
        goalAverage: goalAverage,
        trend: svs.utils.result.getCurrentTrend(trend)
      });
    }
  });
})(Backbone, _, svs);

 })(window);